import React from "react";
import "../common/styles/Navbar.css";
import { useLocation } from "react-router-dom";
import { NavigationRoutes } from "../../constant/Routes";
import AppHeaderDropDown from "../components/AppHeaderDropdown";
import BackButton from "../common/BackButton";

const HeaderLink = () => {
    // if (localStorage.getItem('userEdit')) {
    //     var editData = JSON.parse(localStorage.getItem('userEdit'))
    // }

    const currentLocation = useLocation().pathname;
    var location = getLocation();

    // const navigate = useNavigate();

    function getLocation() {
        if (currentLocation === NavigationRoutes.ADMIN_DASHBOARD) {
            return "Dashboard";
        }

        if (currentLocation ==="/admin-dashboard/dealer-dashboard") {
            return "Dealer Dashboard";
        }
        else if (currentLocation === "/admin-dashboard/categories") {
            return "Categories";
        }
        else if (currentLocation.includes("/admin-dashboard/categories/:")) {
            return "Sub Categories";
        }
        else if (currentLocation.includes("/admin-dashboard/attributes/:")) {
            return "Attributes";
        }
        else if (currentLocation === "/admin-dashboard/banks") {
            return "Banks";
        }
        else if (currentLocation === "/admin-dashboard/billing") {
            return "Payments & Subscriptions";
        }
        else if (currentLocation === "/admin-dashboard/sold-ads") {
            return "Sold Ads";
        }
        else if (currentLocation === "/admin-dashboard/removed-expired-ads") {
            return "Removed / Expired Ads";
        }
        else if (currentLocation === "/admin-dashboard/plans") {
            return "Plans";
        }
        else if (currentLocation === "/admin-dashboard/tiers") {
            return "Tiers";
        }
        else if (currentLocation === "/admin-dashboard/suspicious-activity") {
            return "Suspicious Activity";
        }
        else if (currentLocation === "/admin-dashboard/finance") {
            return "Finance";
        }
        else if (currentLocation === "/admin-dashboard/vehicle") {
            return "Vehicles";
        }
        else if (currentLocation === "/admin-dashboard/content-settings") {
            return "Content Settings";
        }
        else if (currentLocation === "/admin-dashboard/active-admin") {
            return "Active Admin's";
        }
        else if (currentLocation === "/admin-dashboard/verified-user-listing") {
            return "Verified User's";
        }
        else if (currentLocation === "/admin-dashboard/unverified-user-listing") {
            return "Unverified User's";
        }
        else if (currentLocation.includes("admin-dashboard/user-details/")) {
            return <><BackButton />  User Profile </>;
        }
        else if (currentLocation === "/admin-dashboard/vehicle-make") {
            return "Make";
        }
        else if (currentLocation.includes("/admin-dashboard/vehicle-make/:")) {
            return "Vehicle Model/Variant";
        }
        else if (currentLocation.includes("/admin-dashboard/blog")) {
            return "BLOG";
        }
        else if (currentLocation.includes("/admin-dashboard/add-blog")) {
            return "ADD BLOG";
        }
        else if (currentLocation.includes("/admin-dashboard/faqs")) {
            return "FAQ";
        }
        else if (currentLocation.includes("/admin-dashboard/privacy-policy")) {
            return "Privacy Policy";
        }
        else if (currentLocation.includes("/admin-dashboard/terms-and-conditions")) {
            return "Terms And Conditions";
        }

        else if (currentLocation.includes("/admin-dashboard/payment-option")) {
            return "Payment Option";
        }
        else if (currentLocation.includes("/admin-dashboard/gdpr")) {
            return "GDPR";
        }
        else if (currentLocation.includes("/admin-dashboard/contact")) {
            return "Contact";
        }
        else if (currentLocation.includes("/admin-dashboard/ad-reports")) {
            return "AD REPORTS";
        } else if (currentLocation.includes("/admin-dashboard/about-us")) {
            return "ABOUT US";
        }

        else {
            return "DASHBOARD";
        }
    }

    return (
        <div className="container_navbar">
            <div className="navbar_container_start_side">
                <h3 className="fw-bolder ml-4" style={{ color: "#5A607F" }}>{location}</h3>
            </div>
            <div className="navbar_container_end_side">

                <AppHeaderDropDown />
            </div>
        </div>
    );
}

export default HeaderLink;
